import Post from '../api'

//获取所有平台(分组)
export const GetAllPlatform = (param: any): any => {
    return Post('GetAllPlatform', param)
}

//请求app(盘口)
// "_param": {
//    "platform": 11, // 所属平台ID
//}
export const GetAllAppList = (param: any): any => {
    return Post('GetAllAppList', param)
}

//app标签管理
//  "_param": {
//   "tag_type": "smart_tag" // smart_tag智能风控标签 risk_tag风控标签  sms_tag短信标签
//}
export const GetAppTagList = (param: any): any => {
    return Post('GetAppTagList', param)
}

//增加APP标签
//  "_param":{
//    "id":0,  大于0 修改
//   "tag_type":"sms_tag",
//    "tag":"测试标签",
//    "tag_name":"测试标签",
//    "sale_type":null
//}
export const UpdateAppTagLi = (param: any): any => {
    return Post('UpdateAppTagLi', param)
}

//删除APP标签
// "_param": {
//    "action": 1,
//    "ids": [19]
//}
export const BatchAppTagLis = (param: any): any => {
    return Post('BatchAppTagLis', param)
}
//复制标签
//  "_param": {
//    "old_id": 1,
//    "tag_type": "smart_tag",
//   "tag":"测试标签",
//    "tag_name":"测试标签"
//}
export const CopyAppTag = (param: any): any => {
    return Post('CopyAppTag', param)
}

//app风控配置
// "_param": {
//    "platform": 11,
//    "app_id": 588,
//    "risk_tag": 15,
//    "smart_tag": 12,
//    "sms_tag": 17
//}
export const GetTagSetting = (param: any): any => {
    return Post('GetTagSetting', param)
}

//编辑APP风控配置
// "_param": {
//   "platform": 11,
//   "app_id": 588,
//   "risk_tag": 15,
//   "smart_tag": 12,
//    "sms_tag": 17
//}
export const UpdateTagSetting = (param: any): any => {
    return Post('UpdateTagSetting', param)
}

//
export const GetAppInfoList = (param: any): any => {
    return Post('GetAppInfoList', param)
}
// 游戏列表
export const GetAllGameList = (param: any): any => {
    return Post('GetAllGameList', param)
}

/***************************************游戏风控配置****************************************/
//游戏风控列表
export const GetSmartRiskAttrs = (param: any): any => {
    return Post('GetSmartRiskAttrs', param)
}

//// 游戏风控配置
export const GetGameRiskList = (param: any): any => {
    return Post('GetGameRiskList', param)
}

//
export const UpdateGameRisk = (param: any): any => {
    return Post('UpdateGameRisk', param)
}

//
export const GetGameRoomInfo = (param: any): any => {
    return Post('GetGameRoomInfo', param)
}

//
export const DelGameRisk = (param: any): any => {
    return Post('DelGameRisk', param)
}

//
export const UpdateGameRiskStock = (param: any): any => {
    return Post('UpdateGameRiskStock', param)
}

//同步配置
export const RefreshConfig = (param: any): any => {
    return Post('RefreshConfig', param)
}
//// 智能游戏风控配置

export const GetSmartRiskList = (param: any): any => {
    return Post('GetSmartRiskList', param)
}

export const UpdateSmartRiskList = (param: any): any => {
    return Post('UpdateSmartRiskList', param)
}

export const DelSmartRiskList = (param: any): any => {
    return Post('DelSmartRiskList', param)
}

export const GetGameRiskWhites = (param: any): any => {
    return Post('GetGameRiskWhites', param)
}

export const UpdateGameRiskWhite = (param: any): any => {
    return Post('UpdateGameRiskWhite', param)
}

export const QuerySmartRiskInfo = (param: any): any => {
    return Post('QuerySmartRiskInfo', param)
}

export const UpdateGameRiskBlackIp = (param: any): any => {
    return Post('UpdateGameRiskBlackIp', param)
}

export const GetGameRiskBlackIps = (param: any): any => {
    return Post('GetGameRiskBlackIps', param)
}

export const GetSmartRiskAttr = (param: any): any => {
    return Post('GetSmartRiskAttr', param)
}

//获取盘口数据数据
export const GetAppCountData = (params: Object): any => {
    return Post('GetAppCountData', params)
}
//透传
export const TransTopReq = (params: Object): any => {
    return Post('TransTopReq', params)
}

//APP 标签设置
export const UpdateAppTagList = (param: any): any => {
    return Post('UpdateAppTagList', param)
}

export const BatchAppTagList = (param: any): any => {
    return Post('BatchAppTagList', param)
}

/***************************************玩家风控配置****************************************/

//获取玩家风控配置列表
export const GetUserRiskList = (param: any): any => {
    return Post('GetUserRiskList', param)
}

/***************************************个人风控buff设置****************************************/

//个人风控buff列表
export const UserRiskBuffList = (param: any): any => {
    return Post('UserRiskBuffList', param)
}

//修改个人风控buff
export const UpdateUserRiskBuff = (param: any): any => {
    return Post('UpdateUserRiskBuff', param)
}

//删除个人风控buff
export const BatchUserRiskBuff = (param: any): any => {
    return Post('BatchUserRiskBuff', param)
}

//app选的智能风控
export const GetAppSmartList = (params: any): any => {
    return Post('GetAppSmartList', params)
}

//游戏对局详情
export const GetAppUserGameInfo = (params: any): any => {
    return Post('GetAppUserGameInfo', params)
}

/***************************************盘口风控策略趋势****************************************/
export const GetAppGameRisks = (param: any): any => {
    return Post('GetAppGameRisks', param)
}
/***************************************游戏IP黑名单****************************************/
//请求IP黑名单列表
export const GetAllIpBlack = (param: any): any => {
    return Post('GetAllIpBlack', param)
}
//更新IP黑名单列表
export const UpdateIpBlack = (param: any): any => {
    return Post('UpdateIpBlack', param)
}
//删除IP黑名单列表
export const DelIpBlack = (param: any): any => {
    return Post('DelIpBlack', param)
}

/***************************************手机号黑名单管理****************************************/
export const ExportBlackPhone = (param: any): any => {
    return Post('ExportBlackPhone', param)
}
export const SearchBlackPhone = (param: any): any => {
    return Post('SearchBlackPhone', param)
}
export const UpdateBlackPhone = (param: any): any => {
    return Post('UpdateBlackPhone', param)
}
export const BatchUpdateBlackPhone = (param: any): any => {
    return Post('BatchUpdateBlackPhone', param)
}
/***************************************转出黑名单限制管理****************************************/
export const ExportBlackPutInfo = (param: any): any => {
    return Post('ExportBlackPutInfo', param)
}
export const SearchBlackPutInfo = (param: any): any => {
    return Post('SearchBlackPutInfo', param)
}
export const UpdateBlackPutInfo = (param: any): any => {
    return Post('UpdateBlackPutInfo', param)
}
export const DelBlackPutInfo = (param: any): any => {
    return Post('DelBlackPutInfo', param)
}

/***************************************转出用户限制管理****************************************/
export const ExportAccount = (param: any): any => {
    return Post('ExportAccount', param)
}
export const SearchExportAccount = (param: any): any => {
    return Post('SearchExportAccount', param)
}
export const UpdateExportAccount = (param: any): any => {
    return Post('UpdateExportAccount', param)
}
export const DelAllExportAccount = (param: any): any => {
    return Post('DelAllExportAccount', param)
}

//盘口推广数据获取查询配置项
export const GetCustomePage = (param: any): any => {
    return Post('GetCustomePage', param)
}

//盘口推广数据修改查询项配置
export const UpdateCustomePage = (param: any): any => {
    return Post('UpdateCustomePage', param, { showLoading: !param.showLoading })
}
export const GetInfiniteUserList = (param: any): any => {
    return Post('GetInfiniteUserList', param)
}
export const UpdateInfiniteUser = (param: any): any => {
    return Post('UpdateInfiniteUser', param)
}
// 请求倍投风控列表
export const GetDoubleRiskList = (param: any): any => {
    return Post('GetDoubleRiskList', param)
}

// 请求倍投风控列表
export const UpdateDoubleRiskList = (param: any): any => {
    return Post('UpdateDoubleRiskList', param)
}

export const GetAbnotmalStock = (param: any): any => {
    return Post('GetAbnotmalStock', param)
}

export const BatchAbnotmalStock = (param: any): any => {
    return Post('BatchAbnotmalStock', param)
}

export const UploadAbnotmalStock = (param: any): any => {
    return Post('UploadAbnotmalStock', param)
}

export const UpdateAbnotmalStock = (param: any): any => {
    return Post('UpdateAbnotmalStock', param)
}

export const DeleteAllAbnotmalStock = (param: any): any => {
    return Post('DeleteAllAbnotmalStock', param)
}

export const CheckDataPhoneStatus = (param: any): any => {
    return Post('CheckDataPhoneStatus', param)
}
